
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {translate} from '@jsverse/transloco';

@Component({
  selector: 'app-config-dialog-live-component',
  templateUrl: './config-dialog-live-component.html',
  styleUrl: './config-dialog-live-component.scss',
  standalone: false
})

export class ConfigDialogLiveComponent implements OnInit {

  title: string;
  message: string;
  closeButton: string = translate('BUTTONS.CLOSE');
  name: string;


  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {
  }

  ngOnInit(): void {
    this.title = this.data.title || this.title;
    this.message = this.data.description;
  }

  onSupportClick(): void { 
    window.open('https://itsm-servicedesk.temenos.com/', '_blank');
  }
}

